import { createFileRoute } from "@tanstack/react-router";
import AdminPartsEmailTemplates from "@/pages/admin/AdminPartsEmailTemplates";

export const Route = createFileRoute("/_adminLayout/admin/parts/emails")({
  component: AdminPartsEmailTemplates,
});
